var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85.242 46.042 H 61.009 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 22.982 c 1.116 -2.44 1.682 -5.024 1.682 -7.688 c 0 -10.257 -8.345 -18.602 -18.602 -18.602 c -0.802 0 -1.646 0.067 -2.659 0.212 l -0.948 0.136 l -0.176 -0.941 C 61.642 8.375 53.958 2 45.018 2 c -8.941 0 -16.625 6.375 -18.27 15.159 l -0.176 0.942 l -0.948 -0.136 c -1.013 -0.145 -1.857 -0.212 -2.659 -0.212 c -10.257 0 -18.602 8.345 -18.602 18.602 c 0 2.664 0.565 5.247 1.681 7.688 h 23.633 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 H 4.793 l -0.276 -0.556 c -1.429 -2.882 -2.154 -5.954 -2.154 -9.132 c 0 -11.36 9.242 -20.602 20.602 -20.602 c 0.636 0 1.291 0.037 2.012 0.115 C 27.149 6.618 35.431 0 45.018 0 s 17.868 6.618 20.041 15.868 c 0.722 -0.078 1.376 -0.115 2.013 -0.115 c 11.359 0 20.602 9.242 20.602 20.602 c 0 3.179 -0.725 6.251 -2.155 9.132 L 85.242 46.042 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.018 75.383 V 33.612 c 0 -0.552 -0.448 -1 -1 -1 s -1 0.448 -1 1 v 41.771 c -3.578 0.491 -6.347 3.56 -6.347 7.27 c 0 4.051 3.296 7.347 7.347 7.347 s 7.347 -3.296 7.347 -7.347 C 52.364 78.943 49.596 75.873 46.018 75.383 z M 45.018 88 c -2.948 0 -5.347 -2.398 -5.347 -5.347 s 2.398 -5.347 5.347 -5.347 s 5.347 2.398 5.347 5.347 S 47.966 88 45.018 88 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.737 55.498 c -3.711 0 -6.78 2.768 -7.27 6.347 H 55.524 V 33.612 c 0 -0.552 -0.447 -1 -1 -1 s -1 0.448 -1 1 v 30.232 h 19.943 c 0.491 3.578 3.56 6.347 7.27 6.347 c 4.051 0 7.347 -3.296 7.347 -7.347 S 84.788 55.498 80.737 55.498 z M 80.737 68.191 c -2.948 0 -5.347 -2.398 -5.347 -5.347 s 2.398 -5.347 5.347 -5.347 s 5.347 2.398 5.347 5.347 S 83.686 68.191 80.737 68.191 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.546 33.612 c 0 -0.552 -0.448 -1 -1 -1 s -1 0.448 -1 1 v 28.232 H 16.533 c -0.49 -3.578 -3.559 -6.347 -7.27 -6.347 c -4.051 0 -7.347 3.296 -7.347 7.347 s 3.296 7.347 7.347 7.347 c 3.711 0 6.779 -2.768 7.27 -6.347 h 20.013 V 33.612 z M 9.263 68.191 c -2.948 0 -5.347 -2.398 -5.347 -5.347 s 2.398 -5.347 5.347 -5.347 c 2.948 0 5.346 2.398 5.346 5.347 S 12.21 68.191 9.263 68.191 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.006 31.289 c -0.148 0 -0.298 -0.033 -0.44 -0.103 c -0.496 -0.244 -0.7 -0.843 -0.456 -1.339 c 1.849 -3.76 5.599 -6.097 9.787 -6.097 c 0.478 0 0.972 0.039 1.557 0.123 c 0.546 0.078 0.926 0.585 0.848 1.132 c -0.079 0.546 -0.586 0.921 -1.132 0.848 c -0.488 -0.07 -0.893 -0.103 -1.272 -0.103 c -3.42 0 -6.482 1.908 -7.992 4.979 C 13.73 31.084 13.375 31.289 13.006 31.289 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.35223dd5f1a5e4641a8517422d10d123.svg";
export { ForwardRef as ReactComponent };